import React, { useEffect, useState } from "react";
import { Project } from "../types/Project";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import "../styles/Form.css";

interface Props {
  onSave: (project: Project) => void;
  initialData?: Project | null;
  clearAfterSubmit: () => void;
}

const initialState: Project = {
  id: 0,
  name: "",
  owner: "",
  createTimestamp: new Date().toISOString().slice(0, 19).replace("T", " "),
};

const ProjectForm: React.FC<Props> = ({
  onSave,
  initialData,
  clearAfterSubmit,
}) => {
  const [project, setProject] = useState<Project>(initialState);

  useEffect(() => {
    if (initialData) {
      setProject(initialData);
    }
  }, [initialData]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setProject((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(project);
    setProject(initialState);
    clearAfterSubmit();
  };

  const handleClear = () => {
    setProject(initialState);
  };

  return (
    <div>
      <Form onSubmit={handleSubmit}>
        <Row className="mb-1">
          <Col className="form-column">
            <Form.Group controlId="name">
              <Form.Label>
                ProjectName <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={project.name}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group controlId="owner">
              <Form.Label>
                Owner <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="owner"
                value={project.owner}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-1">
          <Col md={12}>
            <div className="form-buttons">
              <Button type="submit" className="btn-save">
                {initialData?.id ? "Update" : "Save"}
              </Button>
              <Button type="button" className="btn-clear" onClick={handleClear}>
                Clear All
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ProjectForm;
